import { Phone } from "lucide-react";
import { BOOKING_URL, BUSINESS } from "@/lib/site";

/** Fixed mobile action bar: call + book. */
export function MobileBookingBar() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-forest-deep/20 bg-surface/95 backdrop-blur-md sm:hidden">
      <div className="grid grid-cols-2 gap-2 p-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
        <a
          href={BUSINESS.phoneHref}
          className="flex min-h-11 items-center justify-center gap-2 rounded-sm border border-forest/30 text-xs font-semibold uppercase tracking-wide text-forest"
        >
          <Phone className="size-4" aria-hidden="true" /> Call
        </a>
        <a
          href={BOOKING_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex min-h-11 items-center justify-center rounded-sm bg-clay text-xs font-semibold uppercase tracking-wide text-accent-foreground"
        >
          Book Your Stay
        </a>
      </div>
    </div>
  );
}
